var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "zmlkn5llua",
    d: "M.63 8.4c-.161 0-.322-.059-.445-.176-.247-.234-.247-.614 0-.848L3.519 4.2.185 1.024C-.062.79-.062.411.185.176c.246-.235.644-.235.89 0l3.78 3.6c.247.234.247.614 0 .848l-3.78 3.6C.954 8.341.792 8.4.63 8.4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-803 -1019) translate(460 1004) translate(332) translate(11 15) translate(2.5 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "q94ddhntjb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zmlkn5llua"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#020303",
    xlinkHref: "#zmlkn5llua"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#q94ddhntjb)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#359EAD",
    d: "M0 0H20.16V19.32H0z",
    transform: "translate(-7.56 -5.88)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.5a45683b3c6acc0c204c9315e2c1a5b0.svg";
export { ForwardRef as ReactComponent };